import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var justify_right_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "M4 15h11V9H4v6zM18.5 4v16H20V4h-1.5z" }) });
export {
  justify_right_default as default
};
//# sourceMappingURL=justify-right.js.map
